var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.hasTitle)?_c('div',{staticClass:"title d-inline-block px-4 py-1"},[_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"content p-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }